import poolgroupinterface from "../interfaces/poolgroupinterface";
import rightinterface from "../interfaces/rightinterface";
import rolerightinterface from "../interfaces/rolerightinterface";


export default {

    data: () => ({
        poolGroups: [],
        poolGroupRights: [],
        selectedRights: [],

        rolePoolGroupRights: [],
        roleAppRights: [],

        appRights: [],
        selectedAppRights: []
    }),

    async getRolePoolGroupRights(role, rolePoolGroupRights) {
        await poolgroupinterface.getPoolGroups(poolGroups => {
            this.poolGroups = poolGroups;
        });

        await rightinterface.getPoolGroupRights(poolGroupRights => {
            this.poolGroupRights = poolGroupRights;
        });

        await rolerightinterface.getRolePoolGroupRights(role.roleId, rolePGRs => {
            this.selectedRights = rolePGRs;
        });

        if (this.selectedRights === undefined) {
            this.selectedRights = null;
        }

        if (role !== undefined && role !== null && role.rolePoolGroupRights !== undefined && role.rolePoolGroupRights !== null) {
            this.selectedRights = role.rolePoolGroupRights;
        }

        let rolePoolGroupRightEntries = null;

        this.createRolePoolGroupRightEntries(role, this.selectedRights, this.poolGroups, this.poolGroupRights, rpgr => {
            rolePoolGroupRightEntries = rpgr;
        });

        rolePoolGroupRights(rolePoolGroupRightEntries);
    },

    createRolePoolGroupRightEntries(role, selectedRights, poolGroups, poolGroupRights, rolePoolGroupRights) {

        let rolePoolGroupRightEntries = [];

        poolGroups.forEach(function (poolGroup) {

            let rightsForOnePoolGroup = [];

            poolGroupRights.forEach(function (right) {

                let rolePoolGroupRight = {
                    rolePoolGroupRightId: null,
                    rightSelected: false,
                    role: {
                        roleId: role.roleId,
                        name: role.name
                    },
                    poolGroup: {
                        poolGroupId: poolGroup.poolGroupId,
                        name: poolGroup.name
                    },
                    right: {
                        rightId: right.rightId,
                        name: right.name
                    }
                };

                if (selectedRights !== undefined && selectedRights != null) {
                    selectedRights.forEach(function (selectedRoleRight) {
                        if (selectedRoleRight != null && selectedRoleRight.right != null
                            && selectedRoleRight.right.rightId === right.rightId
                            && selectedRoleRight.poolGroup != null && selectedRoleRight.poolGroup.poolGroupId === poolGroup.poolGroupId) {

                            rolePoolGroupRight.rightSelected = true;
                            rolePoolGroupRight.rolePoolGroupRightId = selectedRoleRight.rolePoolGroupRightId;
                        }
                    });
                }
                rightsForOnePoolGroup.push(rolePoolGroupRight);
            });
            rolePoolGroupRightEntries.push(rightsForOnePoolGroup);
        });
        rolePoolGroupRights(rolePoolGroupRightEntries);
    },

    async getRoleAppRights(role, roleAppRights) {
        let appRights = null;
        let selectedAppRights = null;

        await rightinterface.getAppRights(rights => {
            appRights = rights;
        });

        await rolerightinterface.getRoleAppRights(role.roleId, roleRights => {
            selectedAppRights = roleRights;
        });

        let appRightsForRole = [];

        if (appRights != null) {
            for (const right of appRights) {

                let roleAppRight = {
                    roleAppRightId: null,
                    rightSelected: false,
                    role: {
                        roleId: role.roleId,
                        name: role.name
                    },
                    right: {
                        rightId: right.rightId,
                        name: right.name
                    }
                };

                if (selectedAppRights !== undefined && selectedAppRights !== null) {
                    selectedAppRights.forEach(function (selectedAppRight) {
                        if (selectedAppRight != null &&
                            selectedAppRight.right != null &&
                            selectedAppRight.right.rightId === right.rightId) {
                            roleAppRight.roleAppRightId = selectedAppRight.roleAppRightId;
                            roleAppRight.rightSelected = true;
                        }
                    });
                }

                appRightsForRole.push(roleAppRight);
            }
        }

        roleAppRights(appRightsForRole);
    }
}



// WEBPACK FOOTER //
// ./src/managers/rolerightmanager.js